
export const URL_ENGLISH_CV = 'https://drive.google.com/file/d/1q8GIaflXiqcFGOG5ZYyaVQWSD0flbeY7/view?usp=sharing'
export const URL_SPANISH_CV = 'https://drive.google.com/file/d/1v5gaAq0o6mODcF7FEbpH_KHeAXy7XbIE/view?usp=sharing'
export const URL_GITHUB =  'https://github.com/SebastianCoppola'